<template>
  <div class="fullwidth">
    <signup-form />

    <main-modal :className="`office-modal`" :show="!hasOffice" @close="closeModal">
      <office-modal @done="officeFilled" />
    </main-modal>
  </div>
</template>

<script>
import signupForm from "@/components/forms/auth/signup";
import officeModal from "@/components/modals/office/officeModal";
import mainModal from "@/components/modals/mainModal";

export default {
  name: "auth-login",
  components: {
    signupForm,
    mainModal,
    officeModal
  },
  data() {
    return {
      hasOffice: false
    };
  },
  methods: {
    closeModal() {},
    officeFilled(office_id) {
      this.hasOffice = true;
      localStorage.setItem("office_id", office_id);
    }
  },
  mounted() {}
};
</script>